// import { Security } from "@mui/icons-material";
// import sandwich from "../../images/sunkIcon/1-sandwich.png";
// import football from "../../images/sunkIcon/2-football.png";
// import Grass from "../../images/sunkIcon/3-Grass.png";
// import Kindergarten from "../../images/sunkIcon/4-Kindergarten.png";
// import Firefox from "../../images/sunkIcon/5-Firefox.png";
// import Sunset from "../../images/sunkIcon/6-Sunset.png";
// import Guacamole from "../../images/sunkIcon/7-Guacamole.png";
// import things from "../../images/sunkIcon/8-Stranger-things.png";
// import Beach from "../../images/sunkIcon/9-Beach.png";

const questions = [
  {
    id: 1,
    title: "Share of Federal Tax Revenue by Income Quintile (2022)",
    desc: "",
    boldText: "",
    answer: "Private Good",
    actual: {
      Top: 67.3,
      Second: 18,
      Middle: 10,
      Fourth: 3.7,
      Bottom: 0.7,
    },
    tooltip:{
      Bottom: "The bottom 20% means that 80% of Americans makes more than them. These are the poorest 20% of Americans.",
      Second: "The second 20% means people in this group make more money than the poorest 20% of Americans, but less than the other 60%.",
      Middle: "This group is in the middle: 40% of Americans makes more than them, and 40% make less.",
      Fourth: "This group is the second richest: they make more than 60% of Americans. Only 20% make more.",
      Top: "This is the richest 20% of the country: they make more than the other 80% of Americans.",
    },
    description: "The U.S. income tax system is progressive: people at the top pay a higher tax rate. Since they also make more money, they will pay more in total. Therefore, the top 20 percent pay the vast majority of taxes in absolute terms. However, it should be noted that other types of taxes like sales tax or capital gains tax are less progressive.",
    wrongAnswerText: "",
    rightAnswerText:"",
  },
];

export default questions;
